<template>
  <gg-btn @click="startAutoSsl" :loading="loading">
    Run AutoSSL Check
  </gg-btn>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import amapi from '@/api/amapi'

export default {
  name: 'StartAutoSsl',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      hosting: 'hosting'
    })
  },
  methods: {
    ...mapActions(['reportSuccess', 'reportError']),
    async startAutoSsl () {
      this.loading = true
      const data = {
        id: this.hosting.id,
        params: {
          uapi_module: 'SSL',
          uapi_function: 'start_autossl_check',
        }
      }
      try {
        await amapi.makecall('cpanel_uapi', data)
        this.reportSuccess('AutoSSL has been started successfully.')
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    }
  },
}
</script>
